module.exports = __webpack_public_path__ + "img/conv_hall_ori.584727f6.jpeg";